import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../../../assets/images/RC_Logo.svg';
import { ROUTES } from '../../../../assets/constants/strings';
import { FaBars, FaCog, FaFileInvoiceDollar, FaRegBell } from 'react-icons/fa';
import { connect } from 'react-redux';
import { logOut } from '../../../../store/User/userActions';
import './style.scoped.scss';
import {
  hasBothPortals,
  canUseApiKeys,
  isSuperAdmin,
  hasDeveloperApi,
  DEVELOPER_API,
} from '../../../../services/entitlements';
import { getEnquiries } from '../../../../services/axios';
import AccountMenu from '../../../AccountMenu';

// const mapStateToProps = (state) => ({
//   documents: state.client.documents,
//   currentDocument: state.document.currentDocument,
//   isPreview: state.client.isPreview,
//   levelOnes: state.client.levelOneList,
//   // logo: state.client.logo,
//   activeRegulators: state.user.user.activeRegulators,
//   activeRegulatedEntities: state.user.user.activeRegulatedEntities,
//   filter: state.user.filter,
// });

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = { logOut };

const connector = connect(mapStateToProps, mapDispatchToProps);

const ApiHeader = ({
  hasNav,
  isHome = false,
  levelOnes,
  // logo,
  handleLevelSelected,
  logOut,
  user,
}) => {
  // Active nav item is derived from the URL path (works for both /api/:section and
  // the static /api/api-keys route).
  const { pathname } = useLocation();
  const admin = isSuperAdmin(user);

  // For a SuperAdmin, the bell surfaces pending API enquiries (an admin's real "notifications") and
  // links to the Enquiries tab. Fetched once; skipped entirely for non-admins.
  const [enquiryCount, setEnquiryCount] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!admin || !user || !user.token) return undefined;
    (async () => {
      const res = await getEnquiries(user.token);
      if (cancelled) return;
      const n = Array.isArray(res)
        ? res.filter((e) => e.product === DEVELOPER_API).length
        : 0;
      setEnquiryCount(n);
    })();
    return () => {
      cancelled = true;
    };
  }, [admin, user]);

  const stripSlash = (p) => (p || '').replace(/\/+$/, '');
  const isActive = (link) => {
    const here = stripSlash(pathname);
    const target = stripSlash(link);
    return here === target || here.startsWith(target + '/');
  };

  // The customer nav is only usable by accounts that hold the Developer API entitlement — the
  // pages guard on it and bounce to /api/activate otherwise. So a pure SuperAdmin (no API sub)
  // sees only the Admin link, not Overview/Docs/Explorer/Pricing (which would just bounce).
  const navItems = [
    ...(hasDeveloperApi(user)
      ? [
          { title: 'Overview', link: ROUTES.APIHOME },
          { title: 'Documentation', link: ROUTES.APIDocs },
          { title: 'API Explorer', link: ROUTES.APIExplorer },
          // API Keys is Production-only — hidden for free/evaluation accounts.
          ...(canUseApiKeys(user) ? [{ title: 'API Keys', link: ROUTES.APIKeys }] : []),
          { title: 'Plans', link: ROUTES.APIPlans },
        ]
      : []),
    // Internal admin area — SuperAdmins only.
    ...(isSuperAdmin(user) ? [{ title: 'Admin', link: ROUTES.APIAdmin }] : []),
  ];

  // Account-menu items also require the API entitlement (same guard) — omit them for a pure admin.
  const dropdownItems = hasDeveloperApi(user)
    ? [
        {
          title: 'Account Settings',
          link: ROUTES.APIAccount,
          icon: <FaCog />,
          onClick: null,
        },
        {
          title: 'Billing & Usage',
          link: ROUTES.APIUsage,
          icon: <FaFileInvoiceDollar />,
          onClick: null,
        },
      ]
    : [];

  // Where the brand logo links: API customers → their portal home; a pure SuperAdmin (no Developer
  // API entitlement) → the admin dashboard, since /api/overview would just bounce to /api/activate.
  const brandTo = hasDeveloperApi(user)
    ? ROUTES.APIHOME
    : isSuperAdmin(user)
    ? ROUTES.APIAdmin
    : ROUTES.APIHOME;

  return (
    <header className='headerApi'>
      {!isHome ? (
        <Link className='headerApi__link' to={brandTo}>
          <img
            id='headerApi-logo'
            className='headerApi__BrandLogo'
            alt='logo'
            src={Logo}
          />
        </Link>
      ) : (
        <img
          className='headerApi__BrandLogo'
          id='headerApi-logo'
          alt='logo'
          src={Logo}
        />
      )}

      <div className='navItems'>
        {navItems.map((item, i) => (
          <Link
            key={i}
            className={`navItems__item ${
              isActive(item.link) ? 'itemActive' : ''
            }`}
            to={item.link}
          >
            <b>{item.title}</b>
          </Link>
        ))}
      </div>

      <div className='headerApi__nav-wrapper'>
        <div className='headerApi__account'>
          {admin && (
            <Link
              className='headerApi__bell'
              to={`${ROUTES.APIAdmin}/enquiries`}
              title={`${enquiryCount} API ${enquiryCount === 1 ? 'enquiry' : 'enquiries'}`}
              aria-label='API enquiries'
            >
              <FaRegBell />
              {enquiryCount > 0 && (
                <span className='headerApi__bell__badge'>{enquiryCount}</span>
              )}
            </Link>
          )}
          <div className='headerApi__account__item dropdown'>
            <AccountMenu
              user={user}
              items={dropdownItems}
              caption={admin ? 'SuperAdmin' : null}
              switcher={
                hasBothPortals(user)
                  ? {
                      label: 'Reader App',
                      title: 'Switch to Reader App',
                      link: ROUTES.HOME,
                    }
                  : null
              }
              onLogout={() => logOut()}
            />
          </div>
        </div>
        {hasNav && (
          <div className='headerApi__navigation dropdown'>
            <button
              id='headerApi-dropdown'
              className='d-flex align-items-center tabIndex-btn p-0'
              data-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
              tabIndex={0}
            >
              <FaBars />
            </button>
            <div className='dropdown-menu dropdown-menu-right'>
              {navItems.map((item, i) => (
                <div
                  key={i}
                  className='dropdown-item active-override'
                  title={item.title}
                  // onClick={() => handleLevelSelected(level)}
                >
                  {item.title}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

// export default connector(ApiHeader);
export default connector(ApiHeader);
